

















import Vue from 'vue'
import NavItem from './AppNavItem.vue'
export default Vue.extend({
  components: { NavItem },
  props: {
    links: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    title() {
      return process.env.VUE_APP_TITLE
    }
  },
  methods: {
    navItemAction(action:string) {
      switch (action) {
        case 'navigate':
          this.$emit('hideNav')
      }
    }
  }
})
